// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-buttons-container {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
}

.try-it-now-button-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.try-it-now-button {
    width: 2rem;
}

.update-list {
    padding-left: 0.5rem;
}

.update-list li {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    gap: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/ArchiveRewardAdPromo.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;AACf","sourcesContent":[".store-buttons-container {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    justify-content: center;\n}\n\n.try-it-now-button-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.try-it-now-button {\n    width: 2rem;\n}\n\n.update-list {\n    padding-left: 0.5rem;\n}\n\n.update-list li {\n    margin-bottom: 0.5rem;\n    margin-top: 0.5rem;\n    gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
